import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import renderCustomBullets from './bullets';

interface SliderCardsOptions {
  desktopSlidesPerView?: number;
}

const initSliderCards = (id: string, total: number, options: SliderCardsOptions = {}): void => {
  const desktopSlidesPerView = options.desktopSlidesPerView ?? 3;

  new Swiper(`#${id} .swiper`, {
    modules: [Navigation, Pagination],
    pagination: {
      el: `#${id} .swiper-pagination`,
      type: 'custom',
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active',
      renderCustom: renderCustomBullets
    },
    navigation: {
      nextEl: `#${id} .swiper-button-next`,
      prevEl: `#${id} .swiper-button-prev`
    },
    spaceBetween: 20,
    speed: 400,
    slidesPerView: 1,
    loop: total > 1,
    breakpoints: {
      1024: {
        slidesPerView: desktopSlidesPerView,
        loop: total > desktopSlidesPerView
      },
      720: {
        slidesPerView: Math.min(2, desktopSlidesPerView),
        loop: total > Math.min(2, desktopSlidesPerView)
      }
    }
  });
};

export default initSliderCards;
